<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="['/machines']" [queryParams]="{search: searchTerm}"><span translate>Machines</span></a>
    </li>
    <li aria-current="page" class="breadcrumb-item active">
      <span translate>Configuration</span>:&nbsp;
      <span [innerText]="machineName"></span>
    </li>
  </ol>
</nav>

<div class="row flex-lg-nowrap">
  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
    <div class="card nav-vertical">
      <div class="card-header"><em class="fa-solid fa-bars"></em><span translate>Configuration</span></div>
      <ul [(activeId)]="show" ngbNav orientation="vertical" (navChange)="onNavChange($event)">
        @if (!isDistributorOrLower) {
          <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.DATA_CONFIG">
            <a (click)="onMenuClick(menuItems.DATA_CONFIG)" ngbNavLink translate>Data configuration</a>
          </li>
        }
        @if (!isDistributorOrLower) {
          <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.STATUS">
            <a (click)="onMenuClick(menuItems.STATUS)" ngbNavLink translate>Status indicator</a>
          </li>
        }
        @if (!isDistributorOrLower) {
          <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.TRAFFIC_LIGHT">
            <a (click)="onMenuClick(menuItems.TRAFFIC_LIGHT)" ngbNavLink translate>Traffic light configuration</a>
          </li>
        }
        <li class="divider my-0"></li>
        <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.TRIGGER_ACTION">
          <a (click)="onMenuClick(menuItems.TRIGGER_ACTION)" ngbNavLink translate>Trigger action</a>
        </li>
        <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.TRIGGER_CONFIGURATION">
          <a (click)="onMenuClick(menuItems.TRIGGER_CONFIGURATION)" ngbNavLink translate>Trigger configuration</a>
        </li>
        @if (externalApiEnabled && (userRole.isSuperAdminRole || userRole.isTechAdminRole)) {
          <li [disabled]="isLoadingMachineDetails"
              [ngbNavItem]="menuItems.API_CONFIG">
            <a (click)="onMenuClick(menuItems.API_CONFIG)" ngbNavLink translate>API configuration</a>
          </li>
        }
        <li class="divider my-0"></li>
        <li [disabled]="isLoadingMachineDetails" [ngbNavItem]="menuItems.METADATA">
          <a (click)="onMenuClick(menuItems.METADATA)" ngbNavLink translate>Metainformation</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="col-12 col-lg">
    <div class="tab-container">

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.DATA_CONFIG) {
        <scitis-admin-machine-data-configuration
            [allSignals]="allSignals"
            [calculatedSignals]="calculatedSignals"
            [userRole]="userRole"
            [machineTag]="machineTag"
            [machine]="machine"
            [statusSignals]="statusSignals"
            [unCalculatedSignals]="unCalculatedSignals">
        </scitis-admin-machine-data-configuration>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.STATUS) {
        <scitis-admin-machine-status-indicator
            [userRole]="userRole"
            [machine]="machine"
            [signalsArray]="allSignals">
        </scitis-admin-machine-status-indicator>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.TRAFFIC_LIGHT) {
        <scitis-admin-machine-traffic-light
            [userRole]="userRole"
            [machineTag]="machineTag"
            [machine]="machine"
            [signalsArray]="allSignals">
        </scitis-admin-machine-traffic-light>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.TRIGGER_ACTION) {
        <scitis-admin-machine-trigger-query
            [userRole]="userRole"
            [machineId]="machine.id"
            [signals]="allSignals">
        </scitis-admin-machine-trigger-query>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.TRIGGER_CONFIGURATION) {
        <scitis-admin-machine-trigger-configuration
            [userRole]="userRole"
            [machine]="machine">
        </scitis-admin-machine-trigger-configuration>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.API_CONFIG) {
        <scitis-admin-machine-api-configuration
            [userRole]="userRole"
            [machine]="machine">
        </scitis-admin-machine-api-configuration>
      }

      @if (!isLoadingMachineDetails && machine.id && show === menuItems.METADATA) {
        <scitis-admin-metadata
            [type]="ELASTIC_SEARCH_TYPE.MACHINE_META_DATA"
            [parent]="machine"
            [isAdminRole]="userRole.isAdminRole"
            [isSuperAdminRole]="userRole.isSuperAdminRole"
            [isTechAdminRole]="userRole.isTechAdminRole">
        </scitis-admin-metadata>
      }


    </div>
  </div>
</div>
